import {
  GET_CUSTOM_PAYMENT_TYPES_REQUESTED,
  GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  GET_CUSTOM_PAYMENT_TYPES_FAILED,
  CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  CREATE_CUSTOM_PAYMENT_TYPES_FAILED,
  UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  UPDATE_CUSTOM_PAYMENT_TYPES_FAILED,
  DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  DELETE_CUSTOM_PAYMENT_TYPES_FAILED,
  SEARCH_CUSTOM_PAYMENT_TYPES,
} from './constants'
import api from 'utils/api'

export const getCustomPaymentTypesRequested = () => ({
  type: GET_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const getCustomPaymentTypesSucceeded = (payload) => ({
  type: GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const getCustomPaymentTypesFailed = () => ({
  type: GET_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const createCustomPaymentTypesRequested = () => ({
  type: CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const createCustomPaymentTypesSucceeded = (payload) => ({
  type: CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const createCustomPaymentTypesFailed = () => ({
  type: CREATE_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const updateCustomPaymentTypesRequested = () => ({
  type: UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const updateCustomPaymentTypesSucceeded = (payload) => ({
  type: UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const updateCustomPaymentTypesFailed = () => ({
  type: UPDATE_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const deleteCustomPaymentTypesRequested = () => ({
  type: DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const deleteCustomPaymentTypesSucceeded = (payload) => ({
  type: DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const deleteCustomPaymentTypesFailed = () => ({
  type: DELETE_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const searchCustomPaymentTypes = (payload) => ({
  type: SEARCH_CUSTOM_PAYMENT_TYPES,
  payload,
})

export const fetchCustomPaymentTypes = (venueUuid) => (dispatch) => {
  dispatch(getCustomPaymentTypesRequested())

  api
    .fetchCustomPaymentTypes(venueUuid)
    .then((response) =>
      dispatch(
        getCustomPaymentTypesSucceeded(
          response.data.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(getCustomPaymentTypesFailed()))
}

export const createCustomPaymentType = (data) => (dispatch) => {
  dispatch(createCustomPaymentTypesRequested())

  return api
    .createCustomPaymentType(data)
    .then((response) =>
      dispatch(
        createCustomPaymentTypesSucceeded(
          response.data.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(createCustomPaymentTypesFailed()))
}

export const updateCustomPaymentType = (data) => (dispatch) => {
  dispatch(updateCustomPaymentTypesRequested())

  return api
    .updateCustomPaymentType(data)
    .then((response) =>
      dispatch(
        updateCustomPaymentTypesSucceeded(
          response.data.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(updateCustomPaymentTypesFailed()))
}

export const deleteCustomPaymentType = (uuid) => (dispatch) => {
  dispatch(deleteCustomPaymentTypesRequested())

  return api
    .deleteCustomPaymentType(uuid)
    .then((response) =>
      dispatch(
        deleteCustomPaymentTypesSucceeded(
          response.data.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(deleteCustomPaymentTypesFailed()))
}
